import React, { useState, useEffect } from "react";
import { SmallCard } from "../Cards/SmallCard";
import {
  get,
  post,
  put,
  deleteRequestV2,
} from "../../api/usersModule/httpClient";
import { useDebounce } from "../../hooks/useDebounce";
import { CDBModal } from "cdbreact";
import { ModalPurchaseOrders } from "../Modals/ModalPurchaseOrders";
import { ModalViewPDF } from "../Modals/ModalViewPDF";
import { LargeCard } from "../Cards/LargeCard";
import swal from "sweetalert";
import Swal from "sweetalert2";

const usersheaders = [
  "ID",
  "Código Proveedor",
  "Proveedor",
  "Descripción",
  "Estado de la orden",
  "Fecha de modificación",
  "Usuario",
  "/purchases",
];

const defaultFormData = {
  IDPurchase: "",
  Nit: "",
  PurchaseDescription: "",
  BillLink: "",
  StatePurchase: "",
  ModificationDate: "",
};

export const CrudPurchaseOrders = ({
  userName,
  permissions,
  project,
  codeSap,
}) => {
  const [data, setData] = useState([]);
  const [state, setState] = useState({ modal6: false, modal7: false });
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [pressedButton, setPressedButton] = useState("");
  const [URL, setURL] = useState("");
  const [action, setAction] = useState("");
  const [initialRender, setInitialRender] = useState(true);
  const [changePage, setChangePage] = useState(false);
  const [providers, setProviders] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const [formData, setFormData] = useState({
    ...defaultFormData,
    user: userName,
  });

  const getData = async (search, statusPage) => {
    try {
      setLoading(true);
      const response = await get(
        `/purchaseOrders?Nit=${project}&search=${search}&page=${statusPage}&limit=${itemsPerPage}`
      );

      if (response && response.answer) {
        setTotalItems(response.pagination.totalItems);
      } else {
        setTotalItems(0);
      }

      setData(response ? response.items : []);
      setLoading(false);
    } catch (error) {
      console.error("Error al obtener los datos:", error);
      setLoading(false);
      setData([]);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al obtener los datos de las órdenes de compra. Por favor, inténtalo de nuevo más tarde.",
        confirmButtonColor: "#146284",
      });
    }
  };

  const getPurchaseOrder = async (ID, toggleNumber) => {
    try {
      const response = await get(`/purchaseOrders?IDPurchase=${ID}`);
      setFormData(response.items[0]);
      toggle(toggleNumber)();
    } catch (error) {
      console.error("Error al obtener la orden de compra:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al obtener la orden de compra. Por favor, inténtalo de nuevo más tarde.",
        confirmButtonColor: "#146284",
      });
    }
  };

  const getProviders = async () => {
    try {
      const response = await get(`/projects?Nit=${project}&list=${true}`);
      setProviders(response.items);
    } catch (error) {
      console.error("Error al obtener los proveedores:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al obtener los proveedores. Por favor, inténtalo de nuevo más tarde.",
        confirmButtonColor: "#146284",
      });
    }
  };

  const closeModal = () => {
    setState({ ...state, modal6: false });
  };

  const closeModal7 = () => {
    setState({ ...state, modal7: false });
  };

  const toggle = (nr) => () => {
    let modalNumber = "modal" + nr;
    setState({ ...state, [modalNumber]: !state[modalNumber] });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const convertDataToArray = () => {
    try {
      return data.map((item) => {
        return [
          item.IDPurchase.toUpperCase(),
          item.Nit.toUpperCase(),
          item.ProjectName.toUpperCase(),
          item.PurchaseDescription.toUpperCase(),
          item.StatePurchase,
          item.ModificationDate,
          item.User.split(" ")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" "),
        ];
      });
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const handleSubmit = () => {
    const requiredFields = ["IDPurchase", "Nit", "StatePurchase", "BillLink"];

    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      swal(
        "Error",
        "Por favor, rellene todos los campos y adjunte un PDF",
        "error"
      );
      setLoading(false);
      return false;
    }

    return true;
  };

  const saveData = async () => {
    Swal.fire({
      title: `${
        action === "create" ? "Creando" : "Actualizando"
      } Orden de Compra`,
      text: "Por favor, espere...",
      icon: "info",
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    const { IDPurchase, Nit, PurchaseDescription, BillLink, StatePurchase } =
      formData;
    const User = userName || "Admin";

    try {
      const response = await (action === "create" ? post : put)(
        "/purchaseOrders",
        {
          IDPurchase: IDPurchase.toUpperCase(),
          Nit: Nit.toUpperCase(),
          PurchaseDescription: PurchaseDescription.toUpperCase(),
          BillLink,
          StatePurchase,
          User: User.split(" ")
            .map(
              (word) =>
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            )
            .join(" "),
        }
      );

      Swal.close();
      if (response && response.response && response.response.status !== 200) {
        swal(
          "Error",
          `No se pudo ${
            action === "create" ? "crear" : "actualizar"
          } la orden de compra. Por favor, revise la información (Puede deberse, a que ya se tiene un ID ya registrada).`,
          "error"
        );
      } else if (response.answer) {
        toggle(6)();
        swal(
          `Orden de compra ${action === "create" ? "creada" : "actualizada"}`,
          `La orden de compra se ${
            action === "create" ? "creó" : "actualizó"
          } correctamente.`,
          "success"
        );
      }

      getData("", 1);
    } catch (error) {
      Swal.close();
      console.error(
        `Error al ${
          action === "create" ? "crear" : "actualizar"
        } la orden de compra:`,
        error
      );
    }
  };

  const deletePurchaseOrder = async () => {
    const body = JSON.stringify({
      IDPurchase: formData.IDPurchase,
      Nit: formData.Nit,
    });

    const confirmDelete = await Swal.fire({
      title: "Confirmar Eliminación de la Orden de Compra",
      text: "Esta acción eliminará de manera permanente la Orden de Compra seleccionada, así como cualquier dato relacionado. ¿Está seguro de que desea proceder?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#146284",
      cancelButtonColor: "#EF4444",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (confirmDelete.isConfirmed) {
      Swal.fire({
        title: "Eliminando Orden de Compra",
        text: "Por favor, espere...",
        icon: "info",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      await deleteRequestV2("purchaseOrders", body, true);

      Swal.close();

      toggle(6)();
      getData("", 1);
    }
  };

  const generateURL = async (fileName, bucketName, origin) => {
    try {
      // Concatenar fileName y bucketName en la URL
      const url = `/purchaseOrders?generateURL=true&fileName=${encodeURIComponent(
        fileName
      )}&bucketName=${encodeURIComponent(bucketName)}`;

      const response = await get(url);

      if (origin === "downloadBill") {
        if (response.answer) {
          window.open(response.url, "_blank");
        } else {
          // Mostrar mensaje de éxito genérico
          Swal.fire({
            title: "Error",
            text: "Error al generar el enlace de descarga.",
            icon: "error",
            confirmButtonColor: "#146284",
          });
        }
      } else if (origin === "viewBill") {
        if (response.answer) {
          setURL(response.url);
          toggle(7)();
        } else {
          // Mostrar mensaje de éxito genérico
          Swal.fire({
            title: "Error",
            text: "Error al generar el enlace de descarga.",
            icon: "error",
            confirmButtonColor: "#146284",
          });
        }
      }
    } catch (error) {
      // Handle error
      console.error("Error generando el enlace:", error);
      // Mostrar mensaje de error genérico
      Swal.fire({
        title: "Error",
        text: "Error al generar el enlace de descarga.",
        icon: "error",
        confirmButtonColor: "#146284",
      });
    }
  };

  const handleDownloadAndViewBill = (origin) => {
    const pressedButtonID = pressedButton.split(",")[1];
    const purchaseData = data.find(
      (item) => item.IDPurchase == pressedButtonID
    );
    const urlParts = purchaseData.BillLink.split("/");
    const bucketName = urlParts[2];
    const fileNameWithExtension = urlParts[urlParts.length - 1];
    const bucketNameWithoutS3 = bucketName.split(".")[0];

    generateURL(fileNameWithExtension, bucketNameWithoutS3, origin);
  };

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }

    if (!changePage) {
      getData(debouncedSearch, page);
    } else {
      setChangePage(false);
    }
  }, [page, initialRender]);

  useEffect(() => {
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [debouncedSearch]);

  useEffect(() => {
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [itemsPerPage]);

  useEffect(() => {
    switch (pressedButton.split(",")[0]) {
      case "create":
        if (permissions["Crear"]) {
          getProviders();
          setAction("create");
          setFormData(defaultFormData);
          toggle(6)();
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para crear una orden de compra",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "edit":
        if (permissions["Editar"]) {
          getProviders();
          setAction("edit");
          getPurchaseOrder(pressedButton.split(",")[1], 6);
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para editar una orden de compra",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "delete":
        if (permissions["Eliminar"]) {
          deletePurchaseOrder(pressedButton.split(",")[1]);
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para borrar una orden de compra",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "downloadBill":
        handleDownloadAndViewBill("downloadBill");

        break;
      case "viewBill":
        handleDownloadAndViewBill("viewBill");

        break;
      case "refresh":
        getData("", page);
        break;
      case "closeModal":
        if (state.modal6) {
          toggle(6)();
        }
        if (state.modal7) {
          closeModal7();
        }
        break;
      case "submitModal":
        const success = handleSubmit();
        if (success) {
          saveData();
        }
        break;
      default:
        break;
    }
    setPressedButton("");
  }, [pressedButton]);

  return (
    <>
      <LargeCard
        name="Ordenes de compra"
        headers={usersheaders}
        loading={loading}
        data={convertDataToArray()}
        totalItems={totalItems}
        customTable={false}
        setPage={setPage}
        page={page}
        setChangePage={setChangePage}
        setPressedButton={setPressedButton}
        setSearch={setSearch}
        cState={true}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
      />
      <CDBModal isOpen={state.modal6} toggle={toggle(8)}>
        <ModalPurchaseOrders
          action={action}
          setPressedButton={setPressedButton}
          formData={formData}
          closeModal={closeModal}
          handleChange={handleChange}
          providers={providers}
          project={project}
          userName={userName || "Admin"}
        />
      </CDBModal>
      <CDBModal isOpen={state.modal7} keyboard={false} toggle={toggle(8)}>
        <ModalViewPDF
          action={action}
          setPressedButton={setPressedButton}
          URL={URL}
          handleChange={handleChange}
          project={project}
          userName={userName}
        />
      </CDBModal>
    </>
  );
};
